import * as React from 'react';

import Tabs from './Tabs';

import s from './NoteContent.module.scss';

const NewsContent: React.FC = () => {
  return (
    <div className={s.root}>
      <Tabs className={s.root__tabs} />
    </div>
  );
};

export default React.memo(NewsContent);
